module.exports = __webpack_public_path__ + "static/media/drinnen_richtig.2cf0bc10.jpg";